import * as React from 'react';
import { useDispatch } from 'react-redux';

import { setPreciseFiltersState } from '../../../actions/preciseFilters';
import { getPreciseFiltersNextState } from './getPreciseFiltersNextState';
import { IGetPreciseFiltersNextStateParams } from '../../../types/redux/preciseFilters';
import { useIsReportStatusDefault } from '../../../utils/report';
import { trackFilterChoice, EFilterChoiceAction } from '../tracking';

export const useHandlePreciseFiltersStateChange = () => {
  const dispatch = useDispatch();
  const isReportStatusDefault = useIsReportStatusDefault();

  return React.useCallback(
    (params: IGetPreciseFiltersNextStateParams, isMainFilter?: boolean) => {
      if (!isReportStatusDefault) {
        return;
      }

      const preciseFiltersNextState = getPreciseFiltersNextState(params);
      dispatch(setPreciseFiltersState(preciseFiltersNextState));
      trackFilterChoice({
        label: `${params.filterName}/${params.filterValue}`,
        action: isMainFilter ? EFilterChoiceAction.Click : EFilterChoiceAction.ClickOnMoreAccuracyPopup,
      });
    },
    [dispatch, isReportStatusDefault],
  );
};
